import { createFileRoute } from '@tanstack/react-router'
import { Teams } from '@/components/settings-route/user/teams/index.jsx'

export const Route = createFileRoute('/_auth/settings/users/organizations')({
  component: Teams,
})
